import { Drawer } from 'antd';
import { ViewResolver } from '@Components/ViewResolver';
import { MobileDrawer } from '@Components/Base/MDrawer';

import styles from './chatbot-drawer.module.css';

interface ChatbotDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

const ChatbotDrawer: React.FC<ChatbotDrawerProps> = ({
  isOpen,
  onClose,
  children,
  footer,
}) => {
  const title = 'Help & Support';

  return (
    <ViewResolver
      desktop={
        <Drawer
          open={isOpen}
          onClose={onClose}
          className={styles.drawer}
          title={title}
          width={410}
          footer={footer}
        >
          {children}
        </Drawer>
      }
      mobile={
        <MobileDrawer
          title={title}
          open={isOpen}
          onClose={onClose}
          className={styles.drawer}
          footer={footer}
          height="100vh"
        >
          {children}
        </MobileDrawer>
      }
    />
  );
};

export default ChatbotDrawer;
